<app-feature>
  <app-feature-title>Upperbelt Files</app-feature-title>

  <mat-card class="mat-elevation-z8">
    <mat-card-content>
      <div class="filters">
        <mat-form-field appearance="fill">
          <mat-label>Type</mat-label>
          <mat-select
            [(ngModel)]="filters.type"
            (selectionChange)="applyFilters()">
            <mat-option value="">All</mat-option>
            <mat-option *ngFor="let type of types" [value]="type">
              {{ type | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Course Name</mat-label>
          <mat-select
            [(ngModel)]="filters.courseName"
            (selectionChange)="applyFilters()">
            <mat-option value="">All</mat-option>
            <mat-option
              *ngFor="let courseName of courseNames"
              [value]="courseName">
              {{ courseName | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Activity Sequence</mat-label>
          <mat-select
            [(ngModel)]="filters.activitySequence"
            (selectionChange)="applyFilters()">
            <mat-option value="">All</mat-option>
            <mat-option
              *ngFor="let activitySequence of activitySequences"
              [value]="activitySequence.toString()">
              {{ activitySequence }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input
            matInput
            [(ngModel)]="filters.name"
            (ngModelChange)="applyFilters()"
            placeholder="Search by activity name" />
        </mat-form-field>

        <button mat-button type="button" (click)="clearFilters()">
          Clear Filters
        </button>
      </div>

      <div class="summary">
        Showing {{ filteredActivities.length }} of
        {{ activities.length }} activities
      </div>

      <div *ngIf="isLoading" fxLayout fxLayoutAlign="center center">
        <mat-spinner></mat-spinner>
      </div>

      <mat-tab-group *ngIf="!isLoading" color="primary">
        <mat-tab label="Ninja Guides">
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th>Activity Sequence</th>
                  <th>Type</th>
                  <th>Course Name</th>
                  <th>Name</th>
                  <th>Activity Type</th>
                  <th>PDF</th>
                  <th>Image</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let activity of filteredActivities;
                    trackBy: trackByActivityId
                  ">
                  <td>{{ getActivitySequenceLabel(activity) }}</td>
                  <td>{{ activity.type | titlecase }}</td>
                  <td>{{ activity.courseName | titlecase }}</td>
                  <td>{{ activity.name | titlecase }}</td>
                  <td>{{ activity.activityType | titlecase }}</td>
                  <td>
                    <input
                      hidden
                      type="file"
                      accept="application/pdf,.pdf"
                      #ninjaPdfInput
                      (change)="
                        onFileSelected($event, activity, 'pdf', 'ninja')
                      " />
                    <button
                      mat-raised-button
                      color="primary"
                      type="button"
                      [disabled]="
                        getUploadState(activity, 'pdf', 'ninja') === 'uploading'
                      "
                      (click)="ninjaPdfInput.click()">
                      <mat-icon>picture_as_pdf</mat-icon>
                      {{ getUploadLabel(activity, "pdf", "ninja") }}
                    </button>
                    <button
                      mat-button
                      color="primary"
                      type="button"
                      (click)="viewPdf(activity, 'ninja')">
                      <mat-icon>visibility</mat-icon>
                      View PDF
                    </button>
                  </td>
                  <td>
                    <input
                      hidden
                      type="file"
                      accept="image/*"
                      #ninjaImageInput
                      (change)="
                        onFileSelected($event, activity, 'image', 'ninja')
                      " />
                    <button
                      mat-raised-button
                      color="accent"
                      type="button"
                      [disabled]="
                        getUploadState(activity, 'image', 'ninja') ===
                        'uploading'
                      "
                      (click)="ninjaImageInput.click()">
                      <mat-icon>image</mat-icon>
                      {{ getUploadLabel(activity, "image", "ninja") }}
                    </button>
                    <button
                      mat-button
                      color="accent"
                      type="button"
                      (click)="viewImage(activity)">
                      <mat-icon>visibility</mat-icon>
                      View Image
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div *ngIf="!filteredActivities.length" class="empty-state">
              No activities match the selected filters.
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Sensei Guides">
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th>Activity Sequence</th>
                  <th>Type</th>
                  <th>Course Name</th>
                  <th>Name</th>
                  <th>Activity Type</th>
                  <th>PDF</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let activity of filteredActivities;
                    trackBy: trackByActivityId
                  ">
                  <td>{{ getActivitySequenceLabel(activity) }}</td>
                  <td>{{ activity.type | titlecase }}</td>
                  <td>{{ activity.courseName | titlecase }}</td>
                  <td>{{ activity.name | titlecase }}</td>
                  <td>{{ activity.activityType | titlecase }}</td>
                  <td>
                    <input
                      hidden
                      type="file"
                      accept="application/pdf,.pdf"
                      #guidesPdfInput
                      (change)="
                        onFileSelected($event, activity, 'pdf', 'guides')
                      " />
                    <button
                      mat-raised-button
                      color="primary"
                      type="button"
                      [disabled]="
                        getUploadState(activity, 'pdf', 'guides') ===
                        'uploading'
                      "
                      (click)="guidesPdfInput.click()">
                      <mat-icon>picture_as_pdf</mat-icon>
                      {{ getUploadLabel(activity, "pdf", "guides") }}
                    </button>
                    <button
                      mat-button
                      color="primary"
                      type="button"
                      (click)="viewPdf(activity, 'guides')">
                      <mat-icon>visibility</mat-icon>
                      View PDF
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div *ngIf="!filteredActivities.length" class="empty-state">
              No activities match the selected filters.
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</app-feature>
